/* External */
import { memo } from 'react';
import PropTypes from 'prop-types';

/* Ott-common */
import Skeleton from '@dtvgo/skeleton';

/* Styles */
import './SwimlaneSkeleton.scss';

function SwimlaneSkeleton({
  withTitle = true,
  children,
}) {
  return (
    <div className="dtv-html5-c-swimlane-skeleton">
      {withTitle && <Skeleton className="dtv-html5-c-swimlane-skeleton__title" />}
      <div className="dtv-html5-c-swimlane-skeleton__card-container">
        {children}
      </div>
    </div>
  );
}

SwimlaneSkeleton.propTypes = {
  withTitle: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

export default memo(SwimlaneSkeleton);
